import React, { useEffect } from 'react';
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { BrowserRouter } from "react-router-dom";
import Store from "./Store";
import "./i18n";
import qs from "qs";
import StoreService from "../../Framework/Services/StoreService";
import ServiceLocator, { Services } from "../ServiceLocator";
import LOCALE_GERMAN from "./i18n";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { ConfiguratorScreen } from "../views/screens/ConfiguratorScreen";
import Api, { baseUrl } from "./Api";
import { get } from "lodash";
import { storeUserData } from "../reducers/User/Actions";
import { useClientFont, withClientFont } from './useClientFont';
const darkTextColor = "#3f3f3f";

const customTheme = createMuiTheme({
  typography: {
    fontFamily: withClientFont("Roboto Condensed"),
    useNextVariants: true,
    h1: {
      color: darkTextColor,
    },
    h2: {
      color: darkTextColor,
    },
    h3: {
      color: darkTextColor,
    },
    h4: {
      color: darkTextColor,
    },
    h5: {
      color: darkTextColor,
    },
    h6: {
      color: darkTextColor,
    },
    subtitle1: {
      color: darkTextColor,
    },
    subtitle2: {
      color: darkTextColor,
    },
    body1: {
      color: darkTextColor,
    },
    body2: {
      color: darkTextColor,
    },
    button: {
      color: darkTextColor,
    },
    caption: {
      color: darkTextColor,
    },
    overline: {
      color: darkTextColor,
    },
  },
  overrides: {
    MuiIcon: { root: { color: darkTextColor } },
  },
});

const Main = () => {
  ServiceLocator.useServiceMap({ StoreService });
  Api.setLanguage(LOCALE_GERMAN.language);
  Services.store.setStore(Store);
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  let client = queryParams.client ? queryParams.client : queryParams._client;

  if (client === "regalwerk" || client === undefined) {
    client = '_default';
  }

  Api.setCustomParam("_client", client);

  useClientFont();

  const token = queryParams.authToken ? queryParams.authToken : get(queryParams, 'shop-user-token');
  Api.setCustomParam("shop-user-token", token);
  Services.store.dispatch(storeUserData(token, client));
  const shareUrl = queryParams.share_url ? queryParams.share_url : queryParams._share_url;
  Api.setCustomParam("_share_url", shareUrl);
  let link = document.createElement("link");
  link.href = `${baseUrl}/dynamic_file/custom_css/${client !== "regalwerk" ? client : "_default"}`;
  link.type = "text/css";
  link.rel = "stylesheet";
  document.getElementsByTagName("head")[0].appendChild(link);
  return (
    <MuiThemeProvider theme={customTheme}>
      <Provider store={Store}>
        <BrowserRouter>
          <Switch>
            <Route path={"/code::code"} component={ConfiguratorScreen} />
            <Route path={"/identifier::identifier"} component={ConfiguratorScreen} />
          </Switch>
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  );
};

export default Main;
